import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { BLOG_POSTS } from "@/data/blog";

export default function Insights() {
  const posts = BLOG_POSTS.slice(0, 4);
  return (
    <section
      id="insights"
      data-testid="insights-section"
      className="border-b border-[#E4E7EC] bg-white"
    >
      <div className="mx-auto max-w-7xl px-5 py-20 md:px-8 md:py-28">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="overline mb-4">§ 10 — Field notes</p>
            <h2 className="font-display text-4xl font-black leading-[0.95] tracking-tight text-[#101828] sm:text-5xl md:text-6xl">
              Regulatory & ops<br />insights.
            </h2>
          </div>
          <div className="flex flex-col items-start gap-3 md:items-end">
            <p className="max-w-md text-base leading-relaxed text-[#475467]">
              Long-form operating knowledge from our desk — the material we
              wish existed when we first tried to import cargo into India.
            </p>
            <Link
              to="/blog"
              data-testid="all-posts-link"
              className="font-mono-accent inline-flex items-center gap-2 text-[#101828] hover:text-[#D92D20]"
            >
              READ ALL POSTS <ArrowRight className="h-3 w-3" strokeWidth={3} />
            </Link>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          {posts.map((p, idx) => (
            <motion.div
              key={p.slug}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.45, delay: idx * 0.06 }}
            >
              <Link
                to={`/blog/${p.slug}`}
                data-testid={`insight-${idx}`}
                className="bento-card group flex h-full flex-col justify-between border-2 border-[#101828] bg-[#F9FAFB] p-6 hover:border-[#D92D20]"
              >
                <div>
                  <span className="font-mono-accent text-[#D92D20]">{p.tag}</span>
                  <h3 className="mt-4 font-display text-lg font-bold leading-tight tracking-tight text-[#101828]">
                    {p.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-[#475467]">
                    {p.description}
                  </p>
                </div>
                <div className="mt-6 flex items-center justify-between border-t border-[#E4E7EC] pt-4">
                  <span className="font-mono-accent text-[#475467]">{p.readTime}</span>
                  <ArrowUpRight
                    className="h-5 w-5 text-[#101828] transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                    strokeWidth={2.5}
                  />
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
